import PropTypes from "prop-types";
import React from "react";

import SvgIcon from "../common/SvgIcon";
import iconSprite from "../../../../images/img/chat/icons.svg";

const MinimizeButton = ({ onClick }) => (
    <div className="minimize-container" onClick={onClick}>
        <SvgIcon src={iconSprite} id="icon-close" />
    </div>
);

MinimizeButton.propTypes = {
    onClick: PropTypes.func,
};

export default MinimizeButton;
